(() => {
  function initProductBenefits(root) {
    if (!root || root.dataset.productBenefitsReady === 'true') return;

    const submitButton = root.querySelector('.product-benefits__button');
    if (!submitButton) return;

    root.dataset.productBenefitsReady = 'true';

    submitButton.addEventListener('click', (e) => {
      if (!e.isTrusted) return;
      document.querySelector('[id^="ProductSubmitButton-"]')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function initAllProductBenefits() {
    document.querySelectorAll('[data-product-benefits]').forEach(initProductBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductBenefits, { once: true });
  } else {
    initAllProductBenefits();
  }
})();
